module.exports = __webpack_public_path__ + "static/012-684a0730a9ecce37f8205f0d01d826dc.jpg";